import { ambassadorRoutes, ambassadorSidebarRoutes } from '../features/ambassadors/routes';
import { partnersRoutes, partnersSidebarRoutes, } from '../features/partners/routes';
import { sponsorshipsRoutes, sponsorshipsSidebarRoutes } from '../features/sponsorships/routes';

export const adminRoutes = [
  ...ambassadorRoutes,
  ...partnersRoutes,
  ...sponsorshipsRoutes,
];

export const sidebarRoutes = [
  ...ambassadorSidebarRoutes,
  ...partnersSidebarRoutes,
  ...sponsorshipsSidebarRoutes,
];
